import { OrbitAPIValidator } from "@withorbit/api";
import { defaultAPIConfig } from "./apiConfig.js";
import { RequestManager } from "./requestManager.js";
import { createBlobFromBuffer, getBytesFromBlobLike } from "./util/fetch.js";
const ajvValidator = new OrbitAPIValidator({
    allowUnsupportedRoute: true,
    mutateWithDefaultValues: false,
});
export class OrbitAPIClient {
    requestManager;
    // TODO: eventually, I'll want to invert control here and bring auth logic into this client.
    constructor(authenticateRequest, config = defaultAPIConfig) {
        this.requestManager = new RequestManager(config, ajvValidator, authenticateRequest);
    }
    listEvents2(query = {}) {
        return this.requestManager.request("/events", "GET", {
            query,
        });
    }
    putEvents2(events) {
        return this.requestManager.request("/events", "PATCH", {
            contentType: "application/json",
            body: events,
        });
    }
    async getAttachment2(id) {
        const blobLike = await this.requestManager.request("/attachments/:id", "GET", {
            query: {},
            params: { id },
        });
        const contents = await getBytesFromBlobLike(blobLike);
        return { contents, mimeType: blobLike.type };
    }
    async putAttachment2(id, mimeType, contents) {
        const blob = await createBlobFromBuffer(contents, mimeType);
        return this.requestManager.request("/attachments/:id", "POST", {
            params: { id },
            contentType: "multipart/form-data",
            body: { file: blob },
        });
    }
    ingestAttachmentsFromURLs2(entries) {
        return this.requestManager.request("/attachments/ingestFromURLs", "POST", {
            contentType: "application/json",
            body: entries,
        });
    }
    getTasks2(taskIDs) {
        return this.requestManager.request("/tasks/bulkGet", "POST", {
            contentType: "application/json",
            body: taskIDs,
        });
    }
}
//# sourceMappingURL=orbitAPIClient.js.map